(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["opus-product-reviews"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('opus-review-grid')) {
  customElements.define('opus-review-grid', class extends HTMLElement {
    connectedCallback() {
      this.grid = this.querySelector('.opus-prev__grid');
      this.btn = this.querySelector('[data-review-more]');
      if (!this.grid || !this.btn) return;
      this.btn.addEventListener('click', () => this.toggle());
    }
    toggle() {
      const expanded = this.grid.classList.toggle('is-expanded');
      this.btn.setAttribute('aria-expanded', String(expanded));
      const label = this.btn.querySelector('[data-more-text]');
      const count = this.btn.querySelector('.opus-prev__more-count');
      if (label) label.textContent = expanded ? (this.btn.dataset.less || 'Show fewer') : (this.btn.dataset.more || 'Show all reviews');
      if (count) count.hidden = expanded;
      if (!expanded) this.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["opus-reviews"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('opus-reviews')) {
  customElements.define('opus-reviews', class extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.opus-rev__track');
      if (!this.track) return;
      this.slides = Array.from(this.track.children);
      this.index = 0;
      this.userPaused = false;
      this.autoplay = this.dataset.autoplay === 'true';
      this.interval = (parseFloat(this.dataset.interval) || 6) * 1000;
      this.reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.timer = null;

      const prev = this.querySelector('[data-rev-prev]');
      const next = this.querySelector('[data-rev-next]');
      const toggle = this.querySelector('[data-rev-toggle]');
      if (prev) prev.addEventListener('click', () => { this.userPaused = true; this.stop(); this.go(this.index - 1); this.reflectToggle(); });
      if (next) next.addEventListener('click', () => { this.userPaused = true; this.stop(); this.go(this.index + 1); this.reflectToggle(); });
      if (toggle) toggle.addEventListener('click', () => this.toggle());

      this.addEventListener('pointerenter', () => this.stop());
      this.addEventListener('pointerleave', () => this.resume());
      this.addEventListener('focusin', () => this.stop());
      this.addEventListener('focusout', () => this.resume());

      let st;
      this.track.addEventListener('scroll', () => { clearTimeout(st); st = setTimeout(() => this.syncIndex(), 120); }, { passive: true });
      document.addEventListener('visibilitychange', () => { if (document.hidden) { this.stop(); } else { this.resume(); } });

      if (this.canAuto()) this.start();
    }
    disconnectedCallback() { this.stop(); }
    canAuto() { return this.autoplay && !this.reduce && !this.userPaused && this.slides.length > 1; }
    go(i) {
      const n = this.slides.length;
      this.index = ((i % n) + n) % n;
      const slide = this.slides[this.index];
      this.track.scrollTo({ left: slide.offsetLeft - this.track.offsetLeft, behavior: this.reduce ? 'auto' : 'smooth' });
    }
    syncIndex() {
      const x = this.track.scrollLeft;
      let best = 0, bestD = Infinity;
      this.slides.forEach((s, i) => { const d = Math.abs((s.offsetLeft - this.track.offsetLeft) - x); if (d < bestD) { bestD = d; best = i; } });
      this.index = best;
    }
    start() { this.stop(); this.setAttribute('data-paused', 'false'); this.timer = setInterval(() => this.go(this.index + 1), this.interval); }
    stop() { if (this.timer) { clearInterval(this.timer); this.timer = null; } }
    resume() { if (this.canAuto() && !this.timer) this.start(); }
    reflectToggle() {
      const btn = this.querySelector('[data-rev-toggle]');
      this.setAttribute('data-paused', this.userPaused ? 'true' : 'false');
      if (btn) { btn.setAttribute('aria-pressed', String(this.userPaused)); btn.setAttribute('aria-label', this.userPaused ? 'Play auto-rotation' : 'Pause auto-rotation'); }
    }
    toggle() {
      this.userPaused = !this.userPaused;
      if (this.userPaused) this.stop(); else this.start();
      this.reflectToggle();
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
